// removed by extract-text-webpack-plugin
module.exports = {"menuActiveText":"orange","menuBg":"#304156","menuHover":"#001528","subMenuBg":"#1f2d3d","borderColor":"#ebeef5"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/index.scss
// module id = yh13
// module chunks = 16